
import { useState } from "react";
import  "./SweetnessIntensity.css";
const SweetnessIntensity = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.sweetnessintensity===0?0:data.sweetnessintensity);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div className="sweetnessIntensity" onChange={onChangeValue}>
    <div class="SweetnessIntensityrating-container">
     
      <div class="SweetnessIntensityrating">
        <form class="SweetnessIntensityrating-form-1" >

          <label for={`SI1F-${count}`}>
        <input type="radio"  name="sweetnessintensity" class="SweetnessIntensity1" id={`SI1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>
  
          <label for={`SI2F-${count}`}>
        <input type="radio" name="sweetnessintensity" class="SweetnessIntensity2" id={`SI2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>
  
          <label for={`SI3F-${count}`}>
        <input type="radio" name="sweetnessintensity" class="SweetnessIntensity3" id={`SI3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>
  
        <label for={`SI4F-${count}`}>
        <input type="radio" name="sweetnessintensity" class="SweetnessIntensity4" id={`SI4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>
       
        </label>
  
          <label for={`SI5F-${count}`}>
        <input type="radio" name="sweetnessintensity" class="SweetnessIntensity5" id={`SI5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>
  

    );
}

export default SweetnessIntensity;